import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LoginStorageModel } from '../../store/login/model';
import { getStorage } from '../../store/utils/storage/storage.manager';

interface PrivateRouteProps {
  Component: React.ComponentType<any>;
  [key: string]: any;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ Component, ...rest }) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    const checkAuthentication = async () => {
      const storageProvider = getStorage();
      const storageInstance = storageProvider.getInstance(LoginStorageModel);
      const loginStorageModel = await storageInstance.find(x => x.modelGuid === 'token');

      const refreshTokenExpired = loginStorageModel && loginStorageModel.refresh_token_expires_on
        && loginStorageModel.refresh_token_expires_on < Date.now() / 1000;

      setIsAuthenticated(!!loginStorageModel && !refreshTokenExpired);
      setIsLoading(false);
    };

    checkAuthentication();
  }, []);

  if (isLoading) {
    return <div>LOADING</div>;
  }

  return isAuthenticated ? <Component {...rest} /> : <Navigate to="/login" state={{ from: location }} />;
};

export default PrivateRoute;


// export default function PrivateRouteWrapper(props: any) {
//   return <PrivateRoute {...props} />;
// }
